import { getElementById } from '@dni-utils/get-element-by-id'
import debounce from 'debounce'
import { useEffect } from 'react'
import { zIndex } from '../tokens/zIndex.stylex'

const toggleDisplay = (element?: HTMLElement | null, show?: boolean) => {
  if (!element) return
  if (show) {
    element.style.display = 'block'
  }
  else {
    element.style.display = 'none'
  }
}

const fixUiCauseByWpadminbar = (adminbar?: HTMLElement | null) => {
  if (adminbar) {
    adminbar.style.zIndex = zIndex.appBar
    document.documentElement.style.marginTop = `${adminbar.offsetHeight}px`
  }
}

interface Config {
  header?: boolean
  footer?: boolean
}

export const useWpLayout = (config?: Config) => {
  const { header = true, footer = true } = config || {}

  useEffect(() => {
    toggleDisplay(getElementById('header'), header)
  }, [header])

  useEffect(() => {
    toggleDisplay(getElementById('footer'), footer)
  }, [footer])

  useEffect(() => {
    // NOTE: WordPress footer 部分品牌會使用決定定位 + padding-bottom 的方式來調整 footer 的位置，因此在 footer 開關時，將 padding-bottom 設為 0 以避免顯示一大片的 padding 空白
    if (!footer) {
      const footerElement: HTMLElement | null = document.querySelector('body > #wrapper')
      if (footerElement) {
        footerElement.style.paddingBottom = '0'
      }
    }
  }, [footer])

  // Observe body class change to detect adminbar
  useEffect(() => {
    // Delay to wait for adminbar to be loaded. Read below link to know how to improve performance
    // https://stackoverflow.com/questions/31659567/performance-of-mutationobserver-to-detect-nodes-in-entire-dom
    const handleWpadminbar = debounce(() => {
      const element = document.body.classList.contains('is-admin') ? getElementById('wpadminbar') : null
      if (element) {
        fixUiCauseByWpadminbar(element)
      }
      observer.disconnect()
      console.debug('[WP Layout] Observer disconnected, Adminbar is shown:', !!element)
    }, 3000)
    const observer = new MutationObserver(handleWpadminbar)
    observer.observe(document.body, {
      attributeFilter: ['class'],
    })

    return () => {
      observer.disconnect()
    }
  }, [])

  // Fix wrong margin-top when adminbar is shown
  useEffect(() => {
    const handleResize = debounce(() => {
      fixUiCauseByWpadminbar(getElementById('wpadminbar'))
    }, 200)
    window.addEventListener('resize', handleResize)
    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [])
}
